
<template>
  <mdb-container class="text-center" style="z-index: unset">
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide>
        <img  src="../assets/images/flags_com/ca2.png" class="item_img rounded-pill"   @click="$router.push('/ca')"  alt=""/>
        <div class="item_name">加拿大</div>
      </swiper-slide>
      <swiper-slide >
        <img  src="../assets/images/flags_com/us.png" class="item_img rounded-pill"   @click="$router.push('/usa')"  alt=""/>
        <div class="item_name">美国</div>
      </swiper-slide>

      <swiper-slide>
        <img  src="../assets/images/flags_com/cy2.png" class="item_img rounded-pill"   @click="$router.push('/cy')"  alt=""/>
        <div class="item_name">塞浦路斯</div>
      </swiper-slide>
      <swiper-slide>
        <img  src="../assets/images/flags_com/ie.png" class="item_img rounded-pill" @click="$router.push('/ie')"   alt=""/>
        <div class="item_name">爱尔兰</div>
      </swiper-slide>
      <swiper-slide>
        <img  src="../assets/images/flags_com/gr.png" class="item_img rounded-pill" @click="$router.push('/gr')"   alt=""/>
        <div class="item_name">希腊</div>
      </swiper-slide>

      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </mdb-container>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'swiper-example-slides-per-column',
  title: 'Multi row slides layout',
  components: {
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 4,
        slidesPerColumn: 1,
        spaceBetween: 2,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  /*@import './base.scss';*/

  .swiper {
    /*height: 430px;*/
    height: 130px;
    margin-left: auto;
    margin-right: auto;

    .swiper-slide {
      height: 200px;
    }
  }

  .swiper .item_img{
    width: 55px;height: 55px;box-shadow: 3px 3px 3px grey;
  }
  .swiper .item_name{
    margin-top: 0.5em; font-weight: bolder;font-size: large;
  }

</style>
